export default class Noder {
  getNodedSubstrings() {}
  computeNodes(segStrings) {}
}
